var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8961 5.33333C5.8961 4.59695 6.49305 4 7.22943 4C7.96581 4 8.56277 4.59695 8.56277 5.33333C8.56277 6.06971 7.96581 6.66667 7.22943 6.66667C6.49305 6.66667 5.8961 6.06971 5.8961 5.33333Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22944 0C5.32165 0 3.76633 0.843147 2.61393 1.80495C1.4631 2.76545 0.674078 3.87619 0.278914 4.5019L0.262857 4.52722C0.184444 4.65065 0.0826346 4.8109 0.0311672 5.03545C-0.0103891 5.21675 -0.0103891 5.44992 0.0311672 5.63122C0.0826344 5.85576 0.184443 6.01602 0.262856 6.13944L0.278915 6.16477C0.674079 6.79048 1.4631 7.90121 2.61393 8.86171C3.76633 9.82352 5.32165 10.6667 7.22944 10.6667C9.13722 10.6667 10.6925 9.82352 11.8449 8.86171C12.9958 7.90121 13.7848 6.79048 14.18 6.16477L14.196 6.13945C14.2744 6.01602 14.3762 5.85577 14.4277 5.63122C14.4693 5.44992 14.4693 5.21675 14.4277 5.03545C14.3762 4.8109 14.2744 4.65064 14.196 4.52722L14.18 4.5019C13.7848 3.87619 12.9958 2.76545 11.8449 1.80495C10.6925 0.843147 9.13722 0 7.22944 0ZM7.22943 2.66667C5.75667 2.66667 4.56276 3.86057 4.56276 5.33333C4.56276 6.80609 5.75667 8 7.22943 8C8.70219 8 9.8961 6.80609 9.8961 5.33333C9.8961 3.86057 8.70219 2.66667 7.22943 2.66667Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ee04f9ffecd7bd16e96b78befd0cb2e6.svg";
export { ForwardRef as ReactComponent };